import React, { useContext, useState } from 'react';
import Workflow from 'components/workflow/Workflow';
import Amount from 'components/sendPayment/Amount';
import LocaleContext from 'components/locale/LocaleContext';
import { FormContext } from '@glu/validation-react';
import { useParams } from 'react-router';

import RecurringTransferForm from './RecurringTransferForm';

const getTitle = (locale, action) => {
  switch (action) {
    case 'modify':
      return locale['common.modifyRecurringInstruction'];
    case 'view':
      return locale['common.viewRecurringInstruction'];
    case 'create':
    default:
      return locale['common.createRecurringInstruction'];
  }
};

export function RecurringTransferWorkflowComponent() {
  const locale = useContext(LocaleContext);
  const { data: values } = useContext(FormContext);
  const { action } = useParams();
  const [canceling, setCanceling] = useState(false);

  return (
    <Workflow
      title={getTitle(locale, action)}
      onBack={() => setCanceling(true)}
      extra={<Amount amount={values?.amount} />}
    >
      <RecurringTransferForm useCanceling={[canceling, setCanceling]} />
    </Workflow>
  );
}

export default RecurringTransferWorkflowComponent;
